import { WidgetPosition, WidgetModuleTransition } from './widget-appearance-settings.i';
import { widgetIconKeys } from './widget-icons';
var WidgetAppearanceSettingsBuilder = /** @class */ (function () {
    function WidgetAppearanceSettingsBuilder() {
        this.item = {
            brandColor: '#4286F4',
            textColor: '#000000',
            iconKey: widgetIconKeys.belt,
            backgroundPatternUrl: 'http://www.stam.img/image.jpg',
            font: {
                name: 'Roboto',
                url: 'https://static.parastorage.com/tag-bundler/api/v1/fonts-cache/googleAPI/css?family=Roboto:400,100,500,300italic,500italic,700italic,900,300&display=swap&_wixCacheBuster=1'
            },
            position: WidgetPosition.RIGHT,
            transition: WidgetModuleTransition.FLIP,
            convex: .5
        };
    }
    WidgetAppearanceSettingsBuilder.prototype.withBrandColor = function (color) {
        this.item.brandColor = color;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withTextColor = function (color) {
        this.item.textColor = color;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withIcon = function (iconKey) {
        this.item.iconKey = iconKey;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withBackgroundPatternUrl = function (url) {
        this.item.backgroundPatternUrl = url;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withFont = function (font) {
        this.item.font = font;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withPosition = function (position) {
        this.item.position = position;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withTransition = function (transition) {
        this.item.transition = transition;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.withConvex = function (convex) {
        this.item.convex = convex;
        return this;
    };
    WidgetAppearanceSettingsBuilder.prototype.build = function () {
        return this.item;
    };
    return WidgetAppearanceSettingsBuilder;
}());
export { WidgetAppearanceSettingsBuilder };
//# sourceMappingURL=widget-appearance-settings.builder.js.map